// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".currency-modal-trigger{display:flex;gap:var(--spacing-xs)}.currency-modal-trigger__flag{height:14px;width:20px}.currency-modal-trigger__title{letter-spacing:normal;text-transform:none}.currency-modal-trigger__icon{height:8px;width:8px}.currency-modal-trigger.critical-component-hide{display:block}.currency-modal-trigger.critical-component-clear{opacity:1}", ""]);
// Exports
module.exports = exports;
